import { useEffect, useState } from "preact/hooks";
import type { DashboardViewModel } from "../app/dashboardViewModel";
import type { Bean } from "../engine/model";
import { Modal } from "./dialogs";

/** All beans, archived included, with Edit / Archive / Unarchive. */
export function BeansDialog(props: {
  open: boolean; vm: DashboardViewModel; onClose: () => void; onEdit: (bean: Bean) => void;
}) {
  const [beans, setBeans] = useState<Bean[]>([]);
  const reload = async () => setBeans(await props.vm.allBeans());
  useEffect(() => { if (props.open) void reload(); }, [props.open]);

  const toggleArchive = async (b: Bean) => {
    if (b.archived) await props.vm.unarchiveBean(b.id as number);
    else await props.vm.updateBean({ ...b, archived: true });
    await reload();
  };

  return (
    <Modal open={props.open} onClose={props.onClose}>
      <h2>Beans</h2>
      <div class="hint">Archived beans are hidden from the pantry; their shots are kept.</div>
      <ul class="plain-list">
        {beans.map((b) => (
          <li key={b.id} class="row">
            <div class="grow">
              <div style={{ fontSize: 14, fontWeight: 500, color: b.archived ? "var(--muted)" : "var(--ink)" }}>
                {b.name}{b.roaster ? ` · ${b.roaster}` : ""}{b.archived ? " (archived)" : ""}
              </div>
              <div class="hint">roasted {b.roastDate}{b.freezeDate ? ` · frozen ${b.freezeDate}` : ""}{b.decaf ? " · decaf" : ""}
                {b.roastLevel !== "unknown" ? ` · ${b.roastLevel.replace("_", "-")}` : ""}</div>
            </div>
            <button class="ghost" type="button" onClick={() => props.onEdit(b)}>Edit</button>
            <button class="ghost" type="button" onClick={() => void toggleArchive(b)}>{b.archived ? "Unarchive" : "Archive"}</button>
          </li>
        ))}
        {beans.length === 0 && <li class="hint">No beans yet.</li>}
      </ul>
      <div class="actions"><button class="secondary" type="button" onClick={props.onClose}>Close</button></div>
    </Modal>
  );
}
